import { supabase } from './supabaseClient';

// ================================
//  인증 함수
// ================================

/** 회원가입 */
export async function authRegister({ email, username, password }) {
  if (!email || !username || !password) return { ok: false, msg: "모든 항목을 입력해주세요." };
  if (username.length < 3) return { ok: false, msg: "아이디는 3자 이상이어야 합니다." };
  if (password.length < 6) return { ok: false, msg: "비밀번호는 6자 이상이어야 합니다." };
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) return { ok: false, msg: "이메일 형식이 올바르지 않습니다." };

  // 중복 체크
  const { data: existing } = await supabase
    .from('users')
    .select('id, username, email')
    .or(`username.eq.${username},email.eq.${email}`)
    .maybeSingle();

  if (existing) {
    if (existing.username === username) return { ok: false, msg: "이미 사용중인 아이디입니다.", dupType: "username" };
    if (existing.email === email) return { ok: false, msg: "이미 사용중인 이메일입니다.", dupType: "email" };
  }

  const { data, error } = await supabase
    .from('users')
    .insert({ email, username, password })
    .select()
    .single();

  if (error) {
    console.error('[authRegister] insert error:', error.message, error.details, error.hint);
    return { ok: false, msg: `서버 오류: ${error.message}` };
  }

  // user_data 초기화
  await supabase.from('user_data').insert({
    user_id: data.id,
    balance: 0,
    inventory: [],
    transactions: [],
    total_payout: 0,
  });

  return { ok: true, dupType: null };
}

/** 로그인 */
export async function authLogin({ username, password }) {
  const { data, error } = await supabase
    .from('users')
    .select('*')
    .eq('username', username)
    .eq('password', password)
    .maybeSingle();

  if (error || !data) return { ok: false, msg: "아이디 또는 비밀번호가 틀렸습니다." };
  return { ok: true, record: data };
}

// ================================
//  데이터 저장/불러오기
// ================================

/** 유저 게임 데이터 불러오기 */
export async function dbLoad(userId) {
  const { data, error } = await supabase
    .from('user_data')
    .select('*')
    .eq('user_id', userId)
    .maybeSingle();

  if (error || !data) return { balance: 0, inventory: [], transactions: [], totalPayout: 0 };

  return {
    balance: parseFloat(data.balance) || 0,
    inventory: data.inventory || [],
    transactions: data.transactions || [],
    totalPayout: parseFloat(data.total_payout) || 0,
  };
}

/** 유저 게임 데이터 저장 */
export async function dbSave(userId, { balance, inventory, transactions, totalPayout }) {
  const { error } = await supabase
    .from('user_data')
    .update({
      balance,
      inventory,
      transactions: transactions.slice(0, 200),
      total_payout: totalPayout,
      updated_at: new Date().toISOString(),
    })
    .eq('user_id', userId);

  if (error) console.error('[DB] Save error:', error.message);
}
